// const API_BASE_URL = "http://localhost/phpValidation/montessori";
const API_BASE_URL = "https://admin.rootsmontessorischool.in/api";

// export const whatsappConfig = {
//   apiVersion: "v23.0",
//   wabaId: "1288188316709199",
//   phoneNumber: "918870518173",
//   phoneNumberId: "1108460152341345",
//   appId: "2011564399401444",
//   accessToken: "EAAclgdV4GeQBR3otX0popWr0uUCM4B8xRe19f35qbQnGV3wZC9xR0sqounfSZAZCm4IZCEZCqc7ZB1Jj6J3cQxJZBrthKY9u1pnhgA5lpm8Ie1PtTTKGSCPOw28nuWNQ4toyHlk6cObZBqXNM9NsBkGCIwODkOFj122yQ6FBQelTfzNe0aypFH2SxtBPNwHC3a6i7wZDZD", // Replace locally with your token
// };
const apiEndpoints = {
  register: `${API_BASE_URL}/register.php`,
  staff: `${API_BASE_URL}/staff_crud.php`,
  dropdown: `${API_BASE_URL}/dynamic_dropdown.php`,
  branches: `${API_BASE_URL}/branches.php`,
  admin_profile: `${API_BASE_URL}/admin_profile.php`,
  announcements: `${API_BASE_URL}/announcements.php`,
  fees: `${API_BASE_URL}/fees_structure.php`,
  timetable: `${API_BASE_URL}/timeTable.php`,
  student: `${API_BASE_URL}/student_crud.php`,
  class: `${API_BASE_URL}/class.php`,
  activity: `${API_BASE_URL}/activities.php`,
  activityStudents: `${API_BASE_URL}/activity_students.php`,
  activityProgress: `${API_BASE_URL}/activity_progress.php`,
  attendance: `${API_BASE_URL}/attendance.php`,
  fee_management: `${API_BASE_URL}/feeManagement.php`,
  fee_request: `${API_BASE_URL}/fee_request.php`,
  transactions: `${API_BASE_URL}/transactions.php`,
  validateToken: `${API_BASE_URL}/jwtautogenerate.php`,
  dashboard: `${API_BASE_URL}/admin_dashboard.php`,
  staffProfile: `${API_BASE_URL}/staff_profile.php`,
  staffAttendance: `${API_BASE_URL}/staff_attendance.php`,
  teacherDashboard: `${API_BASE_URL}/staff_dashboard.php`,
  progresstracking: `${API_BASE_URL}/progress_tracking.php`,
  parentcheck: `${API_BASE_URL}/parentcheck.php`,
  expense_categories: `${API_BASE_URL}/expense_categories.php`,
  staff_salary: `${API_BASE_URL}/staff_salary.php`,
  expense_transactions: `${API_BASE_URL}/expense_transactions.php`,
  reports_financial: `${API_BASE_URL}/reports_financial.php`,
  calendar: `${API_BASE_URL}/calendar.php`,
  sheet_data: `${API_BASE_URL}/sheet_data.php`,
  student_diary: `${API_BASE_URL}/student_diary.php`,
  enquiries: `${API_BASE_URL}/enquiries.php`,
  whatsapp_connections: `${API_BASE_URL}/whatsapp_connections.php`,
  settings: `${API_BASE_URL}/settings.php`,
  scheduleVisits: `${API_BASE_URL}/schedule_visit.php`,
};

export default apiEndpoints;
